

(function () {
  
    "use strict";

    // @ngInject
    function BankAccountDataControllerCtor($scope, $injector, $q, UsersManager, ModalService, AnalyticsService, moment) {
    
        this.constructor.$super.call(this, $scope, $injector);
        AnalyticsService.trackPageView(this, 'BankAccountDataView');
        this.__objectType = 'BankAccountDataController';
        this.moment = moment;

        this.$q = $q;
        this.UsersManager = UsersManager;
        this.ModalService = ModalService;
        this.AnalyticsService = AnalyticsService;
        this.loadingReports = false;


        this.initializeData().then(
            function() {
                this.doneInitilizing = true
            }.bind(this)
        );

        this.doneInitilizing = false;
    }

    Controllers.BankAccountDataController = Class(Controllers.BaseController, {
        constructor: BankAccountDataControllerCtor,




        initializeData: function initializeData() {

            var transactionsPromise = this.UsersManager.getBankTransactions().then(function(resp) {
                this.transactions = resp.data;
            }.bind(this));

            var accountDataPromise = this.UsersManager.getBankData().then(function(resp) {
                this.accountData = resp.data;
            }.bind(this));

            return this.$q.all([transactionsPromise, accountDataPromise]);
        }
    });
    
}());
